import useAppSelector from '../../hooks/useAppSelector';
import useAppDispatch from '../../hooks/useAppDispatch';
import ActiveHelpBubble from '../active-help/ActiveHelpBubble';
import './AssistantButton.less';
import { dispatchEvent } from '../../services/EventService';
import Icon from '../icon/Icon';
import AssistantHome from './AssistantHome';

const AssistantButton = () => {
    const { mode, position } = useAppSelector(state => state.uiState);
    const isActiveHelpVisible = useAppSelector(
        state => state.activeHelpState.isVisible
    );
    const mainFeatureItem = useAppSelector(
        state => state.featureState.mainFeatureItem
    );
    const dispatch = useAppDispatch();
    if (mode === 'full' || mode === 'hidden') {
        return null;
    }
    const isMinimized = mode === 'button' && !!mainFeatureItem;
    return (
        <div
            className={`bri-AssistantButton bri-AssistantButton-position-${position} bri-AssistantButton-mode-${mode}`}
        >
            <div className={`bri-AssistantButton-outer-shape`}>
                <AssistantHome />
                <ActiveHelpBubble />
                <button
                    type="button"
                    className={`bri-AssistantButton-inner-shape ${
                        isActiveHelpVisible ? 'bri-active' : ''
                    } ${isMinimized ? 'bri-AssistantButton-minimized' : ''}`}
                    onClick={() => {
                        if (mode === 'button') {
                            const nextMode = mainFeatureItem ? 'full' : 'menu';
                            dispatch.uiState.setMode(nextMode);
                            nextMode === 'menu' &&
                                dispatchEvent({
                                    type: 'bri.open_widget',
                                    isInteraction: true
                                });
                        } else if (mode === 'menu') {
                            dispatch.uiState.setMode('button');
                            dispatch.featureState.setMenuFeatureItem(null);
                            dispatchEvent({
                                type: 'bri.close_widget',
                                isInteraction: true
                            });
                        }
                        dispatch.activeHelpState.hide();
                    }}
                >
                    <Icon
                        size="x-large"
                        iconId={mode === 'button' ? 'brilliant-logo' : 'close'}
                        className="bri-AssistantButton-icon"
                        color={isMinimized ? 'gradient-primary' : undefined}
                    />
                </button>
            </div>
            {isMinimized && (
                <div className="bri-AssistantButton-badge bri-Body2BoldFont" />
            )}
        </div>
    );
};

export default AssistantButton;
